import axios from 'axios';

const API = axios.create({
  baseURL:  process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
});

API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

// Auth
export const register = (data: object) => API.post('/auth/register', data);
export const login    = (data: object) => API.post('/auth/login', data);

// Links
export const getLinks    = ()                       => API.get('/links');
export const addLink     = (data: object)           => API.post('/links', data);
export const updateLink  = (id: string, data: object) => API.put(`/links/${id}`, data);
export const deleteLink  = (id: string)             => API.delete(`/links/${id}`);
export const getPublicProfile = (username: string)  => API.get(`/links/profile/${username}`);

// User
export const getProfile    = ()              => API.get('/user/me');
export const updateProfile = (data: object)  => API.put('/user/me', data);
export const uploadAvatar  = (data: object)  => API.post('/user/me/avatar', data);

// Analytics
export const trackView   = (username: string) => API.post(`/analytics/track/${username}`);
export const getDeviceAnalytics = () => API.get('/analytics/devices');
export const getAnalytics = ()                => API.get('/analytics/me');

// OTP & Auth
export const sendRegisterOTP = (data: object) => API.post('/auth/send-register-otp', data);
export const sendForgotOTP   = (data: object) => API.post('/auth/forgot-password', data);
export const resetPassword   = (data: object) => API.post('/auth/reset-password', data);
export const googleAuth      = (data: object) => API.post('/auth/google', data);

// Track link click
export const trackLinkClick = (linkId: string) =>  API.post(`/links/click/${linkId}`);

export const getClickAnalytics = () => API.get('/analytics/clicks');
export const updateTheme = (theme: string) => API.put('/user/me', { theme });

export const checkUsername   = (username: string) => API.get(`/user/check-username/${username}`);
export const setUsername     = (username: string) => API.put('/user/me/username', { username });
export const changePassword  = (data: object)     => API.put('/user/me/password', data);
export const subscribeToProfile = (username: string, email: string) => API.post(`/subscribers/${username}`, { email });
export const getMySubscribers   = () => API.get('/subscribers/me/list');

//password protect links
export const verifyLinkPassword = (linkId: string, password: string) =>
  API.post(`/links/verify/${linkId}`, { password });
// Payment APIs
export const createRazorpayOrder   = (plan: string) => API.post('/payment/razorpay/order', { plan });
export const verifyRazorpayPayment = (data: object) => API.post('/payment/razorpay/verify', data);
export const createDodoCheckout    = (plan: string) => API.post('/payment/dodo/checkout', { plan });
export const getSubscriptionStatus = ()             => API.get('/payment/status');

// Link thumbnail
export const uploadLinkThumbnail = (linkId: string, image: string) =>
  API.post('/links/thumbnail', { linkId, image });

// Funnel tracking
export const trackFunnelEvent = (event: string, plan?: string, amount?: number) =>
  API.post('/adminUser/track-funnel', { event, plan, amount });